module.exports = __webpack_public_path__ + "static/media/icon9.a46e7fc2.svg";